import { RouteNames } from '@/types/routes';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: RouteNames.DEBUG,
    path: 'traces',
    redirect: { name: RouteNames.TRACES },
    children: [
      {
        name: RouteNames.TRACES,
        path: '',
        components: {
          default: () => import('@/modules/Traces/views/ListTraces.vue'),
        },
      },
      {
        name: RouteNames.TRACE,
        path: 'studio/:traceId',
        components: {
          default: () => import('@/modules/Traces/views/ViewTrace.vue'),
          sidepanel: () => import('@/modules/Traces/components/SpanDetails/SpanDetails.vue'),
        },
      },
      {
        name: RouteNames.OTEL_TRACE,
        path: 'otel/:traceId',
        components: {
          default: () => import('@/modules/Traces/views/OTelView.vue'),
          sidepanel: () =>
            import('@/modules/Traces/components/SpanOTelDetails/SpanOTelDetails.vue'),
        },
      },
    ],
  },
];

export default routes;
